'use strict';

// vods slider
(function() {
  var $serviceDetailList = $('#js-service-detail-list'),
      $serviceDetailListItem = $('.js-service-detail-list-item');

  $serviceDetailList.slick({
    infinite: false,
    slidesToShow: 7,
    slidesToScroll: 7,
  });
}());

$(function() {
  // anchor scroll
  var $anchor = $('#js-all-service-anchor-link');

  $anchor.on('click', function() {
    var speed = 300,
        href= $(this).attr('href'),
        target = $(href == '#' || href == '' ? 'body' : href),
        position = target.offset().top;

    $('html, body').animate({ scrollTop: position }, speed, 'swing');
    return false;
  });

  // vods slider
  var $serviceDetailListItem = $('.js-service-detail-list-item');

  $serviceDetailListItem.on('click', function() {
    var currentSlug = $(this).data('listSlug');

    $serviceDetailListItem.each(function() {
      if($(this).hasClass('current')) {
        $(this).removeClass('current');
      }
    });

    $(this).addClass('current');

    showServiceDetail(currentSlug);
  });

  var showServiceDetail = function(slug) {
    var $serviceDetailsItem = $('.js-service-details-item');

    $serviceDetailsItem.each(function() {
      if($(this).data('slug') == slug) {
        $(this).addClass('current');
      } else {
        $(this).removeClass('current');
      }
    });
  };

  // tab
  var sortServiceContentsArea = '#js-sort-service-contents-area';

  var $sortService = $('.js-sort-service');

  var data = '';

  $sortService.on('click', function() {
    var sort = $(this).data('sort'),
        order = $(this).data('order'),
        url =  location.pathname + '?sort=' + sort + '&order=' + order;

    if(!$(this).hasClass('disabled')) {
      $('.disabled').removeClass('disabled');
      $(this).addClass('disabled');

      $.ajax({
        dataType: 'html',
        url: url,
        data: data
      }).done(function(data) {
        var sortServiceList = $(data).find(sortServiceContentsArea);

        sortServiceList.hide();

        $(sortServiceContentsArea).replaceWith(sortServiceList);

        $(sortServiceContentsArea).fadeIn(300, function() {
          var observer = lozad('.lazy', {
            loaded: function(el) {
              el.classList.add('is-fade');
            }
          });
          observer.observe();

          sortServiceList.find('.js-tile').tile();
        });

      }).fail(function() {
        console.log('err');
      });
    }
  });
});